import {makeAutoObservable} from "mobx";
import {api} from "../../api";
import {UserProjectionDto} from "../../api/vhs";

class VhsUserStore {
    get users(): Map<String, UserProjectionDto | null> {
        return this._users;
    }

    private set users(value: Map<String, UserProjectionDto | null>) {
        this._users = value;
    }
    private _users: Map<String, UserProjectionDto | null> = new Map<String, UserProjectionDto | null>()

    constructor() {
        makeAutoObservable(this)
    }

    getDisplayName(username: string) {
        const user = this.users.get(username)
        if (!user) {
            return username
        }
        const inactiveFlag = !user.active ? ' (inaktiv)' : ''
        return `${user.firstname} ${user.lastname}${inactiveFlag}`
    }

    async fetchUserByUsername(username: string) {
        if (this.users.has(username)) {
            return
        }
        this.users.set(username, null)
        try {
            const response = await api.vhs.api.getUserByUsername(username) // no catch api
            const responseData = response?.data
            if (responseData) {
                this.users.set(username, responseData)
            }
        } catch (e: any) {}
    }
}
const vhsUserStore = new VhsUserStore()

export {
    vhsUserStore
}
